// Components==============
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useOnClickOutside } from 'utilities/useOnClickOutside';
import { CalendarContext } from '../../Calendar';
import './DatePicker.module.scss';
// =========================

export const formatDate = (log: LogBookEntry) => {
    const getDate = (date: Date) =>
        `${date.getDate()}-${
            date.getMonth() + 1
        }-${date.getFullYear().toString().slice(2, 4)}`;

    const start = getDate(new Date(log.attributes.firstDayOfWeek));
    const end = getDate(new Date(log.attributes.lastDayOfWeek));

    return `${start} - ${end}`;
};

export default function DatePicker({ logs }: { logs: LogBookEntry[] }) {
    const [isOpen, setIsOpen] = useState(false);
    const { activeLog, setActiveLog, canSave, storeLogbook } = useContext(
        CalendarContext
    );

    const ref = useRef<HTMLDivElement>(null);

    useOnClickOutside(ref, () => setIsOpen(false));

    const [counter, setCounter] = useState(0);
    useEffect(() => {
        setCounter(1);
        if (counter === 0) return;
        setActiveLog(logs[logs.length - 1]);
    }, [logs.length]);

    return (
        <div styleName="container" ref={ref}>
            <div styleName="wrapper" onClick={() => setIsOpen((prev) => !prev)}>
                <p>{formatDate(activeLog)}</p>
                <FontAwesomeIcon icon={faChevronDown} />
            </div>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        styleName="options"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        {logs
                            .sort(
                                (a, b) =>
                                    b.attributes.firstDayOfWeek -
                                    a.attributes.firstDayOfWeek
                            )
                            .map((l, i) => (
                                <React.Fragment key={l.key}>
                                    <div
                                        styleName={`option ${
                                            l.key === activeLog.key
                                                ? 'active-log'
                                                : ''
                                        }`}
                                        onClick={() => {
                                            if (canSave) storeLogbook();
                                            setActiveLog(l);
                                            setIsOpen(false);
                                        }}
                                    >
                                        <p>{formatDate(l)}</p>
                                    </div>
                                    {i === logs.length - 1 ? (
                                        <></>
                                    ) : (
                                        <div styleName="bar" />
                                    )}
                                </React.Fragment>
                            ))}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
